import type { ReactNode } from "react";
import { createContext, useContext, useState } from "react";

interface PermissionContextType {
  isPermissionEnabled: boolean;
  setIsPermissionEnabled: (value: boolean) => void;
}

const PermissionContext = createContext<PermissionContextType | undefined>(
  undefined,
);

export function PermissionProvider({ children }: { children: ReactNode }) {
  const [isPermissionEnabled, setIsPermissionEnabled] = useState(false);

  return (
    <PermissionContext.Provider
      value={{ isPermissionEnabled, setIsPermissionEnabled }}
    >
      {children}
    </PermissionContext.Provider>
  );
}

export const usePermissionContext = () => {
  const context = useContext(PermissionContext);
  if (!context) {
    throw new Error(
      "usePermissionContext must be used within PermissionProvider",
    );
  }
  return context;
};
